import { RagDocumentReference } from '../../graphql/schema';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPage,
  faRankingStar,
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import { useSidebarLayout } from '../sidebar/SidebarLayout';
import SidebarHeader from '../sidebar/SidebarHeader';
import FormattedMessage from '../base/FormattedMessage/formattedMessage';

interface Props {
  ragDocumentReferences?: RagDocumentReference[] | null;
}

const MessageRagDocumentReferences = ({ ragDocumentReferences }: Props) => {
  const { setRightSidebarContent } = useSidebarLayout();

  return (
    <div className="flex-col flex">
      <SidebarHeader
        title="RAG Dokumente"
        onClose={() => setRightSidebarContent(null)}
        icon={faTimes}
      />
      <div className="p-5 space-y-5 flex-1 flex flex-col overflow-y-auto">
        {ragDocumentReferences?.map((ref) => (
          <a
            className="w-full space-y-1 block"
            key={ref.id}
            href={ref.url ?? ''}
            target="_blank"
          >
            <div className="flex flex-row space-x-4">
              {ref.relevance && (
                <div className="space-x-1 text-xs">
                  <FontAwesomeIcon icon={faRankingStar} size="sm" />
                  <span>Relevanz: {ref.relevance}</span>
                </div>
              )}
              {ref.pageNumber && (
                <div className="space-x-1 text-xs">
                  <FontAwesomeIcon icon={faPage} size="sm" />
                  <span>Seite:{ref.pageNumber}</span>
                </div>
              )}
            </div>
            {ref.title && <div className="font-semibold">{ref.title}</div>}
            {ref.content && (
              <div className="*:!text-xs text-gray-500">
                <FormattedMessage text={ref.content} />
              </div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

export default MessageRagDocumentReferences;
